import { render, staticRenderFns } from "./SelectSubrubro.vue?vue&type=template&id=32eeed1c&"
import script from "./SelectSubrubro.vue?vue&type=script&lang=js&"
export * from "./SelectSubrubro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VProgressCircular,VSelect})
